import React from 'react'
import { useSelector } from 'react-redux'
import { AskMdtRoot } from 'features/AskMdt'
import { ChatPopupProvider, ChatProvider, ChatPopup } from 'features/Chat'
import AppRoutes from './AppRoutes'
import TrialBanner from 'components/TrialBanner'
import ImpersonationBanner from 'components/ImpersonationBanner'
import setupTrialInterceptor from 'services/setupTrialInterceptor'

// Install the trial-lockout axios interceptor once, at module load.
setupTrialInterceptor()

const Layout = ({ children, isLoggedIn, user }: any) => {
	if (isLoggedIn) {
		// ChatPopupProvider wraps ChatProvider, not the other way around:
		// ChatProvider reads `isOpen` to decide whether a send is a DM or a
		// room message, and the header trigger must not subscribe to the heavy
		// chat context. See features/Chat/ChatPopupContext.tsx.
		return (
			<ChatPopupProvider>
				<ChatProvider>
					{/* Ask MDT (MYD-621): mounts nothing unless AI is offered to this user. */}
					<AskMdtRoot user={user}>
						<div className="App">
							<ImpersonationBanner />
							<TrialBanner />
							{children}
							<ChatPopup />
						</div>
					</AskMdtRoot>
				</ChatProvider>
			</ChatPopupProvider>
		)
	}
	return <main>{children}</main>
}

const App = () => {
	const userLogin = useSelector((state: any) => state.userLogin)
	const isLoggedIn = userLogin.userInfo !== null && userLogin.userInfo !== undefined

	return (
		<div>
			<Layout isLoggedIn={isLoggedIn} user={userLogin.userInfo}>
				<AppRoutes />
			</Layout>
		</div>
	)
}

export default App
